var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" w-full py-4"},[_c('p',{staticClass:" text-sm text-gray-400  text-center"},[_vm._v("©️2021 Sheldon Zhang ")])])}]

export { render, staticRenderFns }